<div aria-labelledby="contact-tab" class="tab-pane fade" id="day2" role="tabpanel">
    <div class="container-fluid">
        <div class="error-list" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p> {{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-block">
            <FlashMessage></FlashMessage>
            <form>
                <div class="form-modified">
                    <div class="empty-data green">
                        <p>
                            You can review the fees and other important notice.
                        </p>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            Fees Notice</label>
                        <div class="col-sm-10">
                            <label class="readonly" for="staticEmail" v-if="!ui.status.canEdit">{{item.noticeData.fees_notice}}</label>
                            <textarea :class="{ 'error-input' : ui.error.errors['CancellationInfo'] }" id="" name="" placeholder="Write fees notice" v-if="ui.status.canEdit" v-model="item.noticeData.fees_notice"></textarea>
                            <validation-error :errors="ui.error.errors" :field="'CancellationInfo'" :isError="ui.error.has_error" v-if="ui.error.has_error" />
                        </div>
                    </div>


                    <div class="form-group row">

                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            Mentions Notice</label>
                        <div class="col-sm-10">
                            <label class="readonly" for="staticEmail" v-if="!ui.status.canEdit">{{item.noticeData.mention_notice}}</label>
                            <textarea :class="{ 'error-input' : ui.error.errors['ExtraInfo'] }" id="" name="" placeholder="Write mention notice" v-if="ui.status.canEdit" v-model="item.noticeData.mention_notice"></textarea>
                            <validation-error :errors="ui.error.errors" :field="'ExtraInfo'" :isError="ui.error.has_error" v-if="ui.error.has_error" />
                        </div>
                    </div>

                    <div class="content-block">
                        <div class="row">
                            <div class="col-md-10 offset-md-2">
                                <button @click.prevent="onEditNoticeClick" class="btn default-btn" type="submit" v-if="!ui.status.canEdit">
                                    Edit
                                </button>
                                <button @click.prevent="createNotice" class="btn default-btn save-btn" type="submit" v-if="ui.status.canEdit">{{buttonName}}
                                    <spinner :loading="ui.status.postLoading.addNotice" v-if="ui.status.postLoading.addNotice"></spinner>
                                </button>
                                <button @click.prevent="cancelNotice" class="btn default-btn cancel" type="submit" v-if="ui.status.canEdit" :disabled="ui.status.postLoading.addNotice">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>